<template>
  <div
    id="app"
    v-if="ready"
    v-loading="isLoading"
    element-loading-background="rgba(255, 255, 255, 0)"
  >
    <router-view class="top" name="top"></router-view>
    <template>
      <router-view
        v-if="Server.status"
        :key="$route.fullPath"
        class="mid"
        name="Content"
      ></router-view>
      <Err500 v-else :message="Server.message" />
    </template>
    <router-view class="bottom" name="bottom"></router-view>

    <div id="kakao-talk-channel-chat-button" @click="kakaoChat()">
      <img src="@/assets/ic_kakao_channel.png?v=1.1" width="62px" />
    </div>

    <popup :option="popup" @close="clearPopup">
      <template slot="content">
        <div v-html="popup.content"></div>
      </template>
    </popup>
    <vs-popup
      :title="$t('selfCertification.title')"
      :active.sync="popupAuthGuide"
    >
      <p class="text-center">
        {{ $t("selfCertification.verificationAccountRegistration") }}
      </p>
      <p class="text-center">{{ $t("selfCertification.completeRequired") }}</p>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            color="#717171"
            @click.prevent="popupAuthGuide = false"
            class="btn-gray btn-block"
            >{{ $t("selfCertification.later") }}</vs-button
          >
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            color="primary"
            onclick="window.location.href='/mypage/auth'"
            class="btn-block custom"
            type="filled"
            >{{ $t("selfCertification.goTo") }}</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>
    <Modals />
  </div>
</template>

<script>
import Popup from "./components/popup/popup";
import { mapGetters, mapState, mapActions } from "vuex";
import GlobalEvent from "@/common/Event";
import Err500 from "@/components/etc/Error";
import Api from "@/common/Api.js";
import "@/util/kakao_config.js";
import Modals from "@/components/common/Modals";

import * as _ from "lodash";

const defaultPopupState = {
  show: false,
  title: "",
  content: "",
  hasHTML: false,
};

export default {
  name: "app",
  metaInfo() {
    return {
      title: this.$t(`pageTitle`),
    };
  },
  async created() {
    // 서버 점검 유무 체크
    const isServerAlived = await this.checkedServer();

    this.isServerStatus = isServerAlived.status;
    if (this.isServerStatus) {
      // await this.AC_SET_FIRE_BASE();

      await this.AC_ZENDESK_URL();
    }
    // set language
    if (this.$cookie.get("lang")) {
      this.$i18n.locale = this.$cookie.get("lang");
      const { set } = this.$meta().addApp("custom");
      set({
        meta: [
          {
            property: "og:locale",
            content: this.$i18n.locale,
          },
        ],
      });
    }
    document.documentElement.lang = this.$i18n.locale;

    this.$ev.$on("lock-body-scroll", () => {
      document.body.style.overflow = "hidden";
    });

    this.$ev.$on("unlock-body-scroll", () => {
      document.body.style.overflow = "";
    });

    GlobalEvent.$on("loading", (isLoading) => {
      this.isLoading = isLoading;
    });

    // vuex init
    await this.$store.dispatch("getInitData").finally(() => {
      this.ready = true;
      this.registGlobalPopupEvents();
    });
    // }
  },
  data() {
    return {
      isLoading: false,
      ready: false,
      popup: { ...defaultPopupState },
      popupAuthGuide: false,
      isServerStatus: false,
    };
  },
  computed: {
    ...mapState(["Server"]),
    ...mapGetters(["marketsByBaseCoin", "marketWithCoin"]),
  },
  updated() {
    const zendesk = document.getElementById("launcher");
    if (zendesk) {
      if (this.$route.path === "/") {
        document.getElementById("launcher").style.visibility = "visible";
      } else {
        document.getElementById("launcher").style.visibility = "hidden";
      }
    }
  },
  methods: {
    ...mapActions("Firebase", ["AC_ZENDESK_URL"]),
    kakaoChat() {
      // 채널 1:1 채팅 버튼을 생성합니다.
      Kakao.Channel.chat({
        channelPublicId: "_CjkSs",
      });
    },
    async checkedServer() {
      if (window.location.host === "m.v1.flybit.com") {
        return await this.checkedOutServer();
      }
      return await this.checkedInOutServer();
    },
    async serverStatus() {
      /* 내부망 예외 코드 -s-  */
      // const apiUrl = await Api.Server.getInnerSeverStatus(); // API(/mobile/version)
      // const { data } = apiUrl;
      // // FIXME: 임시조치 트레블룰
      // const res = await axios.get("https://api.ipify.org"); // ip 확인
      // const whitelist = "222.107.37.97"; // 내부망
      // const whitelist = "222.107.37.103"; // 외부망

      // if (res.data == whitelist) {
      //   console.log("1111");
      //   this.$store.commit("SET_SERVER_VERSION", 4);
      //   this.$store.commit("SET_SERVER_STATUS", true);
      //   this.$store.commit("SET_SERVER_MESSAGE", "");
      //   return;
      // }
      /* 내부망 예외 코드 -e-  */

      try {
        // await axios.get("http://localhost:3030/mobile/versio");
        const apiUrl = await Api.Server.getInnerSeverStatus(); // API(/mobile/version)
        const { data } = apiUrl;
        const res = data.result;
        const serverMessage = data.result.serverMessage;

        return {
          status: res.serverStatus == "true",
          message: {
            top: serverMessage.top,
            mid: serverMessage.mid,
            bottom: serverMessage.bottom,
          },
          version: res.serverVersion,
        };
      } catch (error) {
        try {
          const apiUrl = await Api.Server.getOuterSeverStatus(); // AWS

          const { data } = apiUrl;
          console.log("data-----------", data);
          return {
            status: data.result.serverStatus == "true",
            message: {
              top: data.result.serverMessage.top,
              mid: data.result.serverMessage.mid,
              bottom: data.result.serverMessage.bottom,
            },
            version: data.result.serverVersion,
          };
        } catch (error) {
          return {
            status: false,
            message: {
              top: "서버 점검중입니다.",
              mid: "",
              bottom: "",
            },
            version: 4,
          };
        }
      }
    },

    async checkedInOutServer() {
      if (this.Server.isDataLoading) {
        return;
      }
      this.$store.commit("SET_SERVER_LOADING", true);
      const isInner = await this.serverStatus();
      console.log("isInner-----checkedInOutServer----------", isInner);
      this.$store.commit("SET_SERVER_STATUS", isInner.status);
      this.$store.commit("SET_SERVER_MESSAGE", isInner.message);
      this.$store.commit("SET_SERVER_VERSION", isInner.version);
      return isInner;
    },
    async checkedOutServer() {
      if (this.Server.isDataLoading) {
        return;
      }
      this.$store.commit("SET_SERVER_LOADING", true);
      const OuterStatus = await this.serverStatus("out");

      this.$store.commit("SET_SERVER_VERSION", OuterStatus.version ?? 1);

      // 젠데스크 체팅 버전관리를 위해 window에 버전 저장
      window.version = this.Server.version;

      if (!OuterStatus.status) {
        this.$store.commit("SET_SERVER_STATUS", OuterStatus.status);
        this.$store.commit("SET_SERVER_MESSAGE", OuterStatus.message);
        return OuterStatus;
      }
    },
    clearPopup(close) {
      if (close) {
        return false;
      }
      this.popup.show = false;
      this.popup = { ...defaultPopupState };
    },
    RefreshApp() {
      const appframe = document.createElement("iframe");

      appframe.setAttribute("id", "appframe");
      appframe.setAttribute("name", "appname");
      appframe.setAttribute("style", "visibility: hidden; height: 0");

      appframe.src = "app://flybit?type=refresh";

      document.getElementsByTagName("body")[0].appendChild(appframe);
    },
    registGlobalPopupEvents() {
      this.$ev.$on(
        "popup",
        ({ show = true, title = "", content = "", ...options } = {}) => {
          if (!show) {
            this.clearPopup();
            return true;
          }

          this.popup = {
            show,
            title,
            content,
            ...options,
          };
        }
      );
      this.$ev.$on("authRequired", () => {
        this.popupAuthGuide = true;
      });
      this.$ev.$on("notInMobile", () => {
        this.popup = {
          show: true,
          title: this.$t("unableMobile.title"),
          hasHTML: true,
          content: `<p class="text-center">해당 서비스는 모바일로 지원 되지 않습니다.<br/>추후 오픈 될 예정입니다.</p>`,
          buttons: [{ type: "CANCEL", text: this.$t("confirm.ok") }],
        };
      });
      this.$ev.$on("showEmailConfirmModal", () => {
        this.popup = {
          show: true,
          title: this.$t("verifyEmail.title"),
          hasHTML: true,
          content: `<p class="text-center">${this.$t(
            "verifyEmail.content[0]"
          )}</p><p class="text-center">${this.$t(
            "verifyEmail.content[1]"
          )}</p><p class="text-center"><strong class="txt-red">${this.$t(
            "verifyEmail.content[2]"
          )}</strong></p>`,
          buttons: [
            { type: "CANCEL", text: this.$t("selfCertification.later") },
            {
              type: "OK",
              text: this.$t("selfCertification.goTo"),
              onClick: () => (showEmailConfirmModal = false),
            },
          ],
        };
      });
      this.$ev.$on("pwChangeGuideModal", () => {
        this.popup = {
          show: true,
          title: "비밀번호 재설정",
          hasHTML: true,
          content:
            '<p class="text-center">안전한 비밀번호의 관리와 개인정보 보호를 위해<br>90일(약 3개월)마다 비밀번호를 변경하기를 권장합니다. </p><p class="text-center">비밀번호 재설정 후 안전하게 로그인하세요.</p>',
          buttons: [
            { type: "CANCEL", text: "취소" },
            {
              type: "OK",
              text: "비밀번호 재설정",
              onClick: () => this.$router.push({ name: "PwReset" }),
            },
          ],
        };
      });
      this.$ev.$emit("popupEventRegistered");
    },
  },
  components: {
    Err500,
    Popup,
    Modals,
  },
};
</script>
<style lang="scss">
@import "./styles/index.scss";
@import "./styles/inject.scss";
@import "/src/styles/import.scss";

.top {
}
.mid {
  min-height: calc(100vh - 103px);
  padding: 0px;
  .main-popup {
    .contents {
      position: relative;
      padding: 12px;

      img {
        width: 100%;
      }
    }
  }
}
.bottom {
  bottom: 0;
  left: 0;
  width: 100vw;
  text-align: center;
}
.vs-popup--background {
  pointer-events: none;
}

#kakao-talk-channel-chat-button {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 999999;
  box-shadow: 1px 1px 10px rgba(#d1d5da, 0.5);
  border-radius: 50%;
}
</style>
